import { render } from "./OrdenesRecoleccion.vue?vue&type=template&id=1618125c&scoped=true"
import script from "./OrdenesRecoleccion.vue?vue&type=script&lang=js"
export * from "./OrdenesRecoleccion.vue?vue&type=script&lang=js"

import "./OrdenesRecoleccion.vue?vue&type=style&index=0&id=1618125c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1618125c"]])

export default __exports__